import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from "vuex";
import { ref, computed, onMounted } from 'vue'
import { ProjectUserAccessLogic } from "@/logic/projectUser/ProjectUserAccessesLogic";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { users, user_accesses, projectUserAccessLoading, getUserLastAccesses, getUserAccesses } = ProjectUserAccessLogic();
const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
onMounted(async (): Promise<void> => {
  getUserLastAccesses()
});
const detailView = ref(false);
const detailName = ref("")
const selectUser = async (row: any, _column: any, _event: any) => {
  detailName.value = row.name
  await getUserAccesses(row.id)
  detailView.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: _unref(users),
                onRowClick: selectUser
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "名前"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "last_access_day",
                    label: "最終アクセス日"
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_drawer, {
                modelValue: detailView.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailView).value = $event)),
                size: '50%',
                "with-header": false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(detailName.value), 1),
                  _createVNode(_component_el_table, { data: _unref(user_accesses) }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "day",
                        label: "アクセス日"
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 512), [
            [_directive_loading, _unref(projectUserAccessLoading)]
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})